module.exports = __webpack_public_path__ + "img/mingcute_delete-line.d256f76f.svg";